import React from 'react';
import { Badge } from '@dashboard/components/ui/badge';
import { cn } from '@dashboard/lib/utils';

export default function GuideBadge({ className, ...props }) {
  return (
    <Badge
      variant="outline"
      className={cn('border-primary font-mono text-primary', className)}
      {...props}
    />
  );
}
